import {
  AddIcon,
  CalendarIcon,
  ChatIcon,
  DeleteIcon,
  DownloadIcon,
  PlusSquareIcon,
  SearchIcon,
} from "@chakra-ui/icons";
import {
  Box,
  Button,
  Card,
  CardBody,
  Checkbox,
  Flex,
  FormControl,
  FormHelperText,
  FormLabel,
  HStack,
  Icon,
  IconButton,
  Input,
  Link,
  LinkOverlay,
  ListItem,
  OrderedList,
  Select,
  SimpleGrid,
  Stack,
  Text,
  Textarea,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";
import React, { useState } from "react";

import { CustomToast } from "../Components/Notify";
import FileSaver from "file-saver";
import {Seo} from "../Components/Seo";
import { createEvents } from "ics";
import moment from "moment/moment";
import {
  seoThumbnailUrl,
} from "../Components/imagesLink";

const Tool = () => {
  let [fileContent, setFileContent] = useState({ fileData: "" });
  let [newFileContent, setNewFileContent] = useState({ fileData: "" });
  let [textLen, setTextlen] = useState(0);
  let [parsedContent, setParsedContent] = useState({ events: "" });
  let [eventsLen, setEventsLen] = useState(0);
  let [events, setEvents] = useState({ birthday: "", anniversary: "" });
  let [finalIcs, setFinalIcs] = useState("");
  const [usernames, setUsernames] = useState([{ username: "" }]);

  const [addDuration, setAddDuration] = useState(false);
  const { addToast } = CustomToast();
  const card1Color = useColorModeValue("blue.100", "blue.200");
  const card2Color = useColorModeValue("cyan.200", "cyan.400");

  function handleUsernames(index, event) {
    let newUsernames = [...usernames];
    newUsernames[index][event.target.name] = event.target.value;
    setUsernames(newUsernames);
    // console.log(newUsernames);
  }

  function addUsername() {
    setUsernames([...usernames, { username: "" }]);
  }

  function removeUsername(i) {
    let newUsernames = [...usernames];
    newUsernames.splice(i, 1);
    setUsernames(newUsernames);
  }

  function showContent(event) {
    let file = event.target.files[0];
    // console.log(file);
    let textType = /text.*/;

    if (file.type.match(textType)) {
      var reader = new FileReader();

      reader.onload = function (e) {
        var content = reader.result;
        setFileContent({ fileData: content });
        setNewFileContent({ fileData: content });
        // document.getElementById("fileContent").value = content;
        // console.log(content.length);
        setTextlen(content.length);
      };

      reader.readAsText(file);
    }
  }

  function handleChangeFileContent(event) {
    console.log("file content changed");
    setTextlen(event.target.value.length);
    setNewFileContent(event.target.value);
  }

  function setDateYear(date) {
    let mDate = moment(date, "MM/DD/YYYY");
    mDate = mDate.set("year", moment().year());
    // console.log(mDate,currentDate);
    let isPastDate = mDate.isSameOrBefore();
    if (isPastDate) {
      mDate = mDate.add(1, "years");
    }
    return mDate;
  }

  function findEvents() {
    if (newFileContent.fileData.length > 0) {
      const splitMsgRegex =
        /(?=^\d{1,2}\/\d{1,2}\/\d{2},\s\d{1,2}:\d{2}\s[AP]M)/m;

      const dateRegex =
        /(^(?<date>\d{1,2}\/\d{1,2}\/\d{2}),\s\d{1,2}:\d{2}\s[AP]M)/gm;

      const birthdayRegex =
        // eslint-disable-next-line no-control-regex
        /(?:(?:(?:happy(?:\s|\r|\n)+birthday)|(?:(?:many\s+)+happy(?:\s|\r|\n)+returns(?:\s|\r|\n)+of(?:\s|\r|\n)+the(?:\s|\r|\n)+day))(?:\s|\r|\n)+[^\u0000-\u00ff ]*(?<person>[a-zA-Z ]+))/gim;

      const weddingRegex =
        // eslint-disable-next-line no-control-regex
        /(?:(?:Happy(?:\s|\r|\n)+(?:(?:wedding)?|(?:marriage)?|(?:mrg)?)(?:\s|\r|\n)*anniversary)(?:\s|\r|\n)+[^\u0000-\u00ff ]*(?<person>[a-zA-Z &+]+))/gim;

      let linesContent = newFileContent.fileData
        .split(splitMsgRegex)
        .filter(Boolean);
      // console.log(linesContent);
      // make the list of username to find with birthday and anniversary msg
      const names = usernames.map((e) => e.username);
      // console.log(names);
      let eventsList = [];
      let birthdayList = [];
      let anniversaryList = [];
      linesContent.forEach((element) => {
        if (names.some((name) => element.includes(name))) {
          // two if condition if sometime someone written the
          if (element.toLowerCase().includes("birthday")) {
            // console.log(element,birthdayRegex.test(element));
            let result;
            while (
              birthdayRegex.global &&
              (result = birthdayRegex.exec(element)) !== null
            ) {
              // lastIndex pointer reset to get results correct everytime
              // console.log(result);
              let date = element.slice(0, element.indexOf(",")).trim();
              // console.log(result.groups.person, date);
              const person = result.groups.person.trim();
              if (
                !birthdayList.some((e) => e.person === person) &&
                !birthdayList.some((e) => e.date === date)
              ) {
                date = setDateYear(date);
                birthdayList.push({ person: person, date: date });
                eventsList.push(element);
              }
              // console.log(element);
              // todo add alram feature and without alarm feature
            }
            birthdayRegex.lastIndex = 0;
          }
          if (element.toLowerCase().includes("anniversary")) {
            // console.log(element);
            let result;
            while (
              weddingRegex.global &&
              (result = weddingRegex.exec(element)) !== null
            ) {
              // lastIndex pointer reset to get results correct everytime
              // if (result.index === weddingRegex.lastIndex) {
              //   weddingRegex.lastIndex++;
              // }
              // console.log(result);
              let date = element.slice(0, element.indexOf(",")).trim();
              // console.log(result.groups.person, date);
              const person = result.groups.person.trim();
              if (
                !anniversaryList.some((e) => e.person === person) &&
                !anniversaryList.some((e) => e.date === date)
              ) {
                date = setDateYear(date);
                anniversaryList.push({ person: person, date: date });
                eventsList.push(element);
              }
            }
            weddingRegex.lastIndex = 0;
          }
          // console.log(birthdayList);
          // sort by z to a
          // birthdayList = [...birthdayList].sort((a,b) => (a.person < b.person ? (a.person > b.person ? 1 : 0) : -1));
        }
      });
      let sortOption = document.getElementById("sortOption").value;
      console.log(sortOption);
      if (sortOption === "SortAtoZ") {
        // sort by a to z
        birthdayList = [...birthdayList].sort((a, b) =>
          a.person < b.person ? -1 : a.person > b.person ? 1 : 0
        );
        anniversaryList = [...anniversaryList].sort((a, b) =>
          a.person < b.person ? -1 : a.person > b.person ? 1 : 0
        );
      }
      if (sortOption === "SortByDate") {
        // sorted by date
        birthdayList = [...birthdayList].sort((a, b) => a.date - b.date);
        anniversaryList = [...anniversaryList].sort((a, b) => a.date - b.date);
      }
      setEvents({ birthday: birthdayList, anniversary: anniversaryList });
      setEventsLen(eventsList.length);
      setParsedContent({ events: eventsList });
      if (eventsList.length === 0){
        addToast({ message: "Sorry no events found", type: "warning" });
        setTimeout(() => {
          addToast({ message: "Please enter username for more refined search", type: "warning" });
        }, 1000);
      }
      else{
        addToast({ message: "All events parsed! yay", type: "success" });
        setTimeout(() => {
          addToast({ message: "Please check for duplicate event", type: "info" });
        }, 1000);
        setTimeout(() => {
          addToast({
            message: "Also, you can delete and edit an event",
            type: "info",
          });
        }, 2000);
      }
    } else {
      addToast({
        message: "Please make sure you selected the appropriate file",
        type: "warning",
      });
    }
  }

  // remove birthday
  function birthdayListHandle(index) {
    let newBirthdayList = [...events.birthday];
    newBirthdayList.splice(index, 1);
    setEvents({ birthday: newBirthdayList, anniversary: events.anniversary });
    // console.log(events);
  }

  // edit names birthday
  function birthdayListEditNameHandle(index, value) {
    // console.log(value);
    let newBirthdayList = [...events.birthday];
    newBirthdayList[index].person = value;
    setEvents({ birthday: newBirthdayList, anniversary: events.anniversary });
    // console.log(events);
  }

  // edit dates birthday
  function birthdayListEditDateHandle(index, value) {
    console.log(value);
    let newBirthdayList = [...events.birthday];
    newBirthdayList[index].date = value;
    setEvents({ birthday: newBirthdayList, anniversary: events.anniversary });
    console.log(events);
  }

  // remove anniversary
  function AnniversaryListHandle(index) {
    let newAnniversaryList = [...events.anniversary];
    newAnniversaryList.splice(index, 1);
    setEvents({ birthday: events.birthday, anniversary: newAnniversaryList });
    // console.log(events);
  }

  // edit names
  function AnniversaryListEditNameHandle(index, value) {
    // console.log(value);
    let newAnniversaryList = [...events.anniversary];
    newAnniversaryList[index].person = value;
    setEvents({ birthday: events.birthday, anniversary: newAnniversaryList });
    // console.log(events);
  }

  // edit names
  function AnniversaryListEditDateHandle(index, value) {
    // console.log(value);
    let newAnniversaryList = [...events.anniversary];
    newAnniversaryList[index].date = value;
    setEvents({ birthday: events.birthday, anniversary: newAnniversaryList });
    // console.log(events);
  }

  function eventToIcs(icsEvents, icsAlarms, eventType) {
    let targetEvents;
    if (eventType === "Birthday") {
      targetEvents = events.birthday;
    } else {
      targetEvents = events.anniversary;
    }
    if (targetEvents.length > 0) {
      targetEvents.forEach((element) => {
        try {
          let person = element.person;
          console.log(element.date.format("MM/DD/YY"));
          let mDate, mDDate, start, end;
          if (addDuration == true) {
            const startTime = document.getElementById("startTime").value;
            const endTime = document.getElementById("endTime").value;
            mDate = moment(
              element.date.format("MM/DD/YY") + " " + startTime,
              "MM/DD/YY hh:mm"
            );
            mDDate = moment(
              element.date.format("MM/DD/YY") + " " + endTime,
              "MM/DD/YY hh:mm"
            );
            start = [
              mDate.year(),
              mDate.month() + 1,
              mDate.date(),
              mDate.hour(),
              mDate.minute(),
            ];
            end = [
              mDDate.year(),
              mDDate.month() + 1,
              mDDate.date(),
              mDDate.hour(),
              mDDate.minute(),
            ];
          } else {
            mDate = moment(element.date.format("MM/DD/YY"), "MM/DD/YY");
            mDDate = moment(element.date.format("MM/DD/YY"), "MM/DD/YY");
            start = [mDate.year(), mDate.month() + 1, mDate.date()];
            end = [mDDate.year(), mDDate.month() + 1, mDDate.date()];
            // let currentDate = moment();
            // // mDate = mDate.year(moment().year());
            // // mDate = mDate.set("year", moment().year());
            // // console.log(mDate,currentDate);
            // // let isPastDate = mDate.isSameOrBefore();
            // // if (isPastDate) {
            // //   console.log("Yes, Past date to create event", person);
            // //   mDate = mDate.add(1, "years");
            // // }
            // mDDate = moment(mDate.format("MM/DD/YY hh:mm"), "MM/DD/YY hh:mm");
            // mDDate = mDDate.add({ hours: 23, minutes: 59 });
          }
          // create an event to push in list of events
          let event = {
            productId: "WpEventIcs",
            start: start,
            end: end,
            title: person + "'s " + eventType,
            alarms: icsAlarms,
            recurrenceRule:
              "FREQ=YEARLY;BYMONTH=" +
              (mDate.month() + 1) +
              ";BYMONTHDAY=" +
              mDate.date(),
            categories: ["family"],
            calName: "WpCalendar",
          };
          // console.log(element);
          // console.log(event);
          icsEvents.push(event);
        } catch (error) {
          console.log(error);
        }
      });
    }
    return icsEvents;
  }

  function makeEvents() {
    if (events.birthday.length <= 0 && events.anniversary.length <= 0) {
      addToast({
        message:
          "calendar file not available because you don't have any events",
        type: "warning",
      });
    } else {
      let icsEvents = [];
      let icsAlarms = [];
      let hour = 8;
      let minute = 30;

      // icsAlarms.push({
      //   action: "audio",
      //   description: "Reminder",
      //   trigger: { hours: 2, minutes: 30, before: true },
      //   repeat: 2,
      //   attachType: "VALUE=URI",
      //   attach: "Glass",
      // });
      icsAlarms.push({
        action: "display",
        description: "Reminder",
        trigger: { hours: 0, minutes: 10, before: true },
      });

      icsEvents = eventToIcs(icsEvents, icsAlarms, "Birthday");
      icsEvents = eventToIcs(icsEvents, icsAlarms, "Anniversary");

      try {
        createEvents(icsEvents, (error, value) => {
          if (error) {
            console.log(error);
          }
          console.log(value);
          setFinalIcs(value);
          document.getElementById("icsEventsText").value = value;
        });
        // console.log(finalIcs);
        addToast({
          message: "calendar file successfully generated!yay",
          type: "success",
        });
      } catch (error) {
        alert("Make calendar event error");
        console.log(error);
      }
    }
  }

  function downloadIcs() {
    if (document.getElementById("icsEventsText").value !== "") {
      console.log(finalIcs);
      var icsFileContent = new Blob([finalIcs], {
        type: "text/calendar;charset=utf-8",
      });
      FileSaver.saveAs(icsFileContent, "wpEventIcs.ics");
      addToast({
        message: "ics file successfully downloaded.",
        type: "success",
      });
    } else {
      addToast({
        message: "ics file not available because you don't have any events.",
        type: "warning",
      });
    }
  }

  function setEndTime(value) {
    console.log(value);
    const endTime = document.getElementById("endTime");
    let endHrs = parseInt(value.split(":")[0]);
    let endMin = parseInt(value.split(":")[1]) + 1;
    if (endMin >= 60) {
      endMin = endMin - 60;
      endMin = String(endMin);
      endHrs += 1;
      endHrs = String(endHrs);
    }
    if (String(endMin).length === 1) {
      endMin = "0" + String(endMin);
    }
    if (String(endHrs).length === 1) {
      endHrs = "0" + String(endHrs);
    }
    endTime.setAttribute("min", endHrs + ":" + endMin);
  }

  function fixEndTime(value) {
    const endTime = document.getElementById("endTime");
    console.log(value, endTime.value, endTime.getAttribute("value"));
    const endTimeMin = endTime.getAttribute("min");
    const endTimeMax = endTime.getAttribute("max");
    if (value < endTimeMin) {
      endTime.setAttribute("value", endTimeMin);
      endTime.value = endTimeMin;
    } else if (value > endTimeMax) {
      endTime.setAttribute("value", endTimeMax);
      endTime.value = endTimeMax;
    }
  }

  return (
    <div>
        <Seo
          title="Tool - WpCalendar | Whatsapp chat to calendar events!"
          description="Effortlessly convert WhatsApp chat events to calendar events with our privacy-conscious tool. Keep track of important dates without compromising your data privacy."
          type="website"
          name="Soham_UltraHopeful"
          url="https://wpcalendar.vercel.app/tool"
          imageUrl={seoThumbnailUrl}
        />
      {/* Main Content part */}
      <SimpleGrid columns={1} spacing={[10, 8, 5]} p={5}>
        {/* Inputs for users */}
        <Stack direction={["column", "column"]} as="form">
          <Text fontSize="md">
            To <b>export chat</b> from WhatsApp Follow below steps:
          </Text>
          <OrderedList px={7}>
            <ListItem>click on top-right 3 dots</ListItem>
            <ListItem>Select more option</ListItem>
            <ListItem>
              Select <b>export chats</b>
            </ListItem>
            <ListItem>
              Select <b>without media</b> option
            </ListItem>
            <ListItem>Send .txt file to yourself in Whatsapp or Email</ListItem>
          </OrderedList>
          <Text mt={4} fontSize={"2xl"}>
            <b>Step 1</b>
          </Text>
          <FormControl>
            <FormLabel>
              <b>File Selection</b>
            </FormLabel>
            <label htmlFor="fileInp" className="fileInputLabel">
              Browse For Files<Icon ml={1} as={PlusSquareIcon}></Icon>
            </label>
            <Input
              type="file"
              accept=".txt"
              onChange={(e) => showContent(e)}
              id="fileInp"
              border={0}
              width={["100%", "auto"]}
              display={["flex", "inline-flex"]}
              mt={["3", "3", "0"]}
            />
            <FormHelperText>We'll never save your file</FormHelperText>
          </FormControl>
        </Stack>
        {/* file content */}
        <VStack alignItems={"flex-start"}>
          <Text fontSize={"md"} fontWeight={"500"}>
            File Content
          </Text>
          <Textarea
            placeholder="Your file content appears here after file selection"
            id="fileContent"
            value={newFileContent.fileData}
            onChange={(e) => {
              handleChangeFileContent(e);
            }}
            rows={"10"}
            autoComplete="off"
            spellCheck={false}
          />
          <Text fontSize={"sm"}>Text length : {textLen}</Text>
          <Text fontSize="md">
            To find <b>Username</b> : Click on your profile and check the Your
            Name field
          </Text>
          <Stack
            direction={["column", "row"]}
            alignItems={["baseline", "center"]}
          >
            <Text fontSize={"md"} fontWeight="500">
              What's your Username in chat?
            </Text>
            <Button
              rightIcon={<AddIcon />}
              colorScheme={"green"}
              size={"sm"}
              width={"fit-content"}
              onClick={() => addUsername()}
            >
              Add
            </Button>
          </Stack>
          {usernames.map((element, index) => (
            <Stack
              direction={["column", "row"]}
              alignItems={["baseline", "center"]}
              width={["100%", "90%", "60%", "50%"]}
              key={index}
            >
              <Text fontSize={"md"} fontWeight={"400"}>
                Username
              </Text>
              <Input
                name="username"
                type="text"
                minW={"50px"}
                id={index + "username"}
                value={element.username}
                onChange={(event) => handleUsernames(index, event)}
              ></Input>
              {index ? (
                <Button
                  rightIcon={<DeleteIcon />}
                  colorScheme={"red"}
                  size={"sm"}
                  width={"fit-content"}
                  px={5}
                  onClick={() => removeUsername(index)}
                >
                  Remove
                </Button>
              ) : null}
            </Stack>
          ))}
          <Text size={"md"}>Select sorting option:</Text>
          <Select
            id="sortOption"
            defaultValue={"NoSort"}
            width={["100%", "30%"]}
          >
            <option value="NoSort">No Sort</option>
            <option value="SortAtoZ">Sort A to Z</option>
            <option value="SortByDate">Sort by Date</option>
          </Select>
          <Button
            id="findEventBtn"
            rightIcon={<SearchIcon />}
            colorScheme={"blue"}
            onClick={findEvents}
          >
            Find Events from text
          </Button>
        </VStack>
        {/* parsed content start */}
        <VStack alignItems={"flex-start"}>
          <Text mt={4} fontSize={"2xl"}>
            <b>Step 2</b>
          </Text>
          <Text fontSize={"md"} fontWeight={"500"}>
            Parsed Events
          </Text>
          <Textarea
            placeholder="Your found events will be shown here"
            id="fileContent"
            value={parsedContent.events}
            rows={"10"}
            autoComplete="off"
            spellCheck={false}
            readOnly={true}
          />
          <Text fontSize={"sm"}>Events Found : {eventsLen}</Text>
          <Text>
            Below is the list of Birthday and Anniversary to customise as per
            your interest/to remove the duplicate events
          </Text>
          <Text>Birthday list</Text>
          <Box maxHeight={"300px"} width={"100%"} overflowY={"scroll"}>
            <SimpleGrid
              columns={[1, 2, 3, 4, 5]}
              spacingX="40px"
              spacingY="20px"
              width={"100%"}
            >
              {events.birthday.length <= 0 ? (
                <Text fontSize={"md"}>No events/birthday to show</Text>
              ) : (
                events.birthday.map((element, index, error) => (
                  <Card key={index} id={index} bg={card1Color}>
                    <CardBody pt={2} pb={0} color={"black"}>
                      <Flex justifyContent={"space-between"}>
                        <VStack alignItems={"baseline"}>
                          <Input
                            variant="outline"
                            className="editNameInput"
                            placeholder="Enter name"
                            value={element.person}
                            onChange={(event) =>
                              birthdayListEditNameHandle(
                                index,
                                event.target.value
                              )
                            }
                          />
                          <Text align={"left"}>'s Birthday</Text>
                        </VStack>
                        <IconButton
                          icon={<DeleteIcon />}
                          alignSelf={"start"}
                          colorScheme={"red"}
                          bg={"red.400"}
                          size={"sm"}
                          px={5}
                          onClick={() => birthdayListHandle(index)}
                        />
                      </Flex>
                      <Input
                        variant="outline"
                        type="date"
                        className="editDateInput"
                        placeholder="Enter name"
                        value={moment(element.date).format("YYYY-MM-DD")}
                        min={moment().format("YYYY-MM-DD")}
                        onChange={(event) =>
                          birthdayListEditDateHandle(index, event.target.value)
                        }
                      />
                    </CardBody>
                  </Card>
                ))
              )}
            </SimpleGrid>
          </Box>
          <Text fontSize={"sm"}>
            Birthday List Count : {events.birthday.length}
          </Text>
          <br />
          <Text>Anniversary list</Text>
          <Box maxHeight={"300px"} width={"100%"} overflowY={"scroll"}>
            <SimpleGrid
              columns={[1, 2, 3, 4, 5]}
              spacingX="40px"
              spacingY="20px"
              width={"100%"}
            >
              {events.anniversary.length <= 0 ? (
                <Text fontSize={"md"}>No events/Anniversary to show</Text>
              ) : (
                events.anniversary.map((element, index, error) => (
                  <Card key={index} id={index} bg={card2Color}>
                    <CardBody pt={2} pb={0} color={"black"}>
                      <Flex>
                        <VStack alignItems={"baseline"}>
                          <Input
                            variant="outline"
                            className="editNameInput"
                            placeholder="Enter name"
                            value={element.person}
                            onChange={(event) =>
                              AnniversaryListEditNameHandle(
                                index,
                                event.target.value
                              )
                            }
                          />
                          <Text align={"left"}>'s Anniversary</Text>
                        </VStack>
                        <IconButton
                          icon={<DeleteIcon />}
                          colorScheme={"red"}
                          bg={"red.400"}
                          size={"sm"}
                          px={5}
                          onClick={() => AnniversaryListHandle(index)}
                        />
                      </Flex>
                      <Input
                        variant="outline"
                        type="date"
                        className="editDateInput"
                        placeholder="Enter name"
                        value={moment(element.date).format("YYYY-MM-DD")}
                        min={moment().format("YYYY-MM-DD")}
                        onChange={(event) =>
                          AnniversaryListEditDateHandle(
                            index,
                            event.target.value
                          )
                        }
                      />
                    </CardBody>
                  </Card>
                ))
              )}
            </SimpleGrid>
          </Box>
          <Text fontSize={"sm"}>
            Anniversary List Count : {events.anniversary.length}
          </Text>
          <Stack as="form">
            <Checkbox
              isChecked={addDuration}
              onChange={(e) => {
                e.preventDefault();
                setAddDuration(!addDuration);
              }}
            >
              Add Duration instead of all day
            </Checkbox>
            {addDuration ? (
              <VStack alignItems={"baseline"}>
                <Text fontSize={"md"}>Start Time</Text>
                <Input
                  id="startTime"
                  type="time"
                  max="23:49"
                  onChange={(event) => {
                    setEndTime(event.target.value);
                  }}
                ></Input>
                <Text fontSize={"md"}>End Time</Text>
                <Input
                  id="endTime"
                  type="time"
                  min=""
                  max="23:59"
                  onChange={(event) => {
                    fixEndTime(event.target.value);
                  }}
                ></Input>
              </VStack>
            ) : (
              ""
            )}
            <Button
              id="makeCalendarEventBtn"
              rightIcon={<CalendarIcon />}
              colorScheme={"blue"}
              onClick={makeEvents}
              width={"fit-content"}
            >
              Make calendar event
            </Button>
          </Stack>
        </VStack>
        {/* parsed content end */}
        {/* events content */}
        <VStack alignItems={"flex-start"}>
          <Text mt={4} fontSize={"2xl"}>
            <b>Step 3</b>
          </Text>
          <Text fontSize={"md"} fontWeight={"500"}>
            Events
          </Text>
          <Textarea
            id="icsEventsText"
            placeholder="Your all events you can see here"
            rows={"10"}
            readOnly={true}
          />
          <Button
            id="downloadFileBtn"
            rightIcon={<DownloadIcon />}
            colorScheme={"blue"}
            onClick={downloadIcs}
          >
            Download ics file
          </Button>
        </VStack>
        {/* export events to calendar information */}
        <VStack alignItems={"flex-start"}>
          <Text fontSize="md">
            Before Export please create new calendar to export this events into
            that new calendar to delete all the events anytime in future
          </Text>
          <OrderedList px={7}>
            <ListItem>
              Left-hand Side in Google Calendar Other Calendars click on + sign
            </ListItem>
            <ListItem>Select option "Create new calendar"</ListItem>
            <ListItem>Write the name you want</ListItem>
          </OrderedList>
          <Text fontSize="md">
            To <b>export events to google calendar </b>Follow below steps:
          </Text>
          <OrderedList px={7}>
            <ListItem>Go to settings</ListItem>
            <ListItem>Select Import & Exports</ListItem>
            <ListItem>Select new calendar you created</ListItem>
            <ListItem>Go to import</ListItem>
            <ListItem>
              Select the downloaded file and see the magic!!!!
            </ListItem>
          </OrderedList>
        </VStack>
        <HStack>
          <Button
            as={LinkOverlay}
            href={"/report"}
            colorScheme="teal"
            rightIcon={<ChatIcon />}
            size={['sm','md']}
          >
            Report Bug / Suggest a feature
          </Button>
        </HStack>
      </SimpleGrid>
    </div>
  );
};

export default Tool;
